<template>
    <b-dropdown
        no-caret
        variant="primary"
        class="sku-fba-dropdown"
        menu-class="sku-fba-dropdown-menu"
        toggle-class="sku-fba-dropdown-toggle"
        title="Ürünü FBA Ürününe Çevir"
        size="sm"
    >
        <template #button-content>
            <feather-icon icon="RepeatIcon" />
        </template>
        <b-dropdown-item
            v-for="azStore in azStores"
            :key="azStore.id"
            size="sm"
            @click="convertToFbaProduct(azStore.id)"
        >
            {{ azStore.store_name }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from '@/libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
    props: {
        merchantSku: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters('store', ['_stores']),
        azStores(){
            return this._stores.filter(store => store.marketplace_code == 'AZ')
        }
    },
    methods: {
        convertToFbaProduct(storeId) {
      axios.post('/amazon/fba/product/convert/fba', {
        store_id: storeId,
        merchant_sku: this.merchantSku
      })
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.status  === 'success' ? res.data.message : 'İşlem Başarısız',
                variant: res.data.status  === 'success' ? 'success' : 'danger',
                icon: res.data.status  === 'success' ? 'CheckIcon' : 'XIcon',
              }
            })
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error?.response?.data?.message || 'İşlem başarısız',
                variant: 'danger',
                icon: 'XIcon',
              }
            })
          })
    },
    }
};
</script>

<style scoped>
.sku-fba-dropdown {
  display: inline-flex;
}

::v-deep .sku-fba-dropdown-menu {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.25rem;
  width: 28rem;
  padding: 0.5rem;
}

::v-deep .sku-fba-dropdown-menu > li {
  width: auto;
}

::v-deep .sku-fba-dropdown-menu > li > .dropdown-item {
  width: 100%;
  white-space: normal;
}
</style>